import { IS_WHITE_LABEL } from '@/shared/environments';
import { isTrackingDisabled } from '@/shared/lib/isTrackingDisabled';

import { TRIAL_VARIANT_EXPERIMENT_START } from './constants';

/** White-label builds have no experiment, and marked automated tests must keep a stable start screen. */
export const isExcludedFromTrialVariant = () => IS_WHITE_LABEL || isTrackingDisabled();

/** Whether a user without a stored assignment signed up during the experiment (see TRIAL_VARIANT_EXPERIMENT_START). */
export const isCreatedDuringTrialExperiment = (createdDate: null | string | undefined) =>
  Date.parse(createdDate ?? '') >= Date.parse(TRIAL_VARIANT_EXPERIMENT_START);
